"use strict";

exports.__esModule = true;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _d3visualization = require("../../helpers/assets-helpers/d3visualization");

var _d3visualization2 = _interopRequireDefault(_d3visualization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WebpackAssets = function (_React$Component) {
  (0, _inherits3.default)(WebpackAssets, _React$Component);

  function WebpackAssets() {
    (0, _classCallCheck3.default)(this, WebpackAssets);
    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
  }

  WebpackAssets.prototype.componentDidMount = function componentDidMount() {
    (0, _d3visualization2.default)({
      refs: this.refs,
      data: this.props.assets
    });
  };

  WebpackAssets.prototype.render = function render() {
    return _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement("ul", { ref: "dataView" })
      ),
      _react2.default.createElement("div", { ref: "assets" })
    );
  };

  return WebpackAssets;
}(_react2.default.Component);

exports.default = WebpackAssets;


WebpackAssets.propTypes = {
  assets: _react.PropTypes.array
};


//////////////////
// WEBPACK FOOTER
// ../~/electrode-electrify-react-component/lib/components/sub-components/assets-visualization.js
// module id = 555
// module chunks = 0